import React from 'react';
import '../App.css';

export default class CommentCreator extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  async submitComment(event) {
    event.preventDefault();
    console.log('Submitting comment...');
    console.log('State comment is : ' + this.state.comment);
    let comment = this.state.comment;
    let url = window.location.protocol + '//' + window.location.host;
    let fullUrl = `${url}/api/v1/posts/${this.props.post._id['$oid']}/comments`;
    if (this.props.comment_id) {
      // This is a reply to an existing comment...
      fullUrl += 'comment_id=' + this.props.comment_id;
    }
    let reqData = {
      uri: fullUrl,
      method: 'POST'
    };
    let that = this;
    let formData = new FormData();
    formData.append('comment[text]', comment);
    if (this.props.commentId) {
      formData.append('comment_id', this.props.commentId);
    }
    reqData.body = formData;
    try {
      const d = await fetch(reqData.uri, reqData);
      if (d.status !== 429) {
        d.json().then(data => {
          let newComment = data['comments'];
          newComment.user = that.props.user;
          if (that.props.commentObj) {  // This is a reply....
            let oldReplies = that.props.commentObj.state.replies;
            oldReplies.push(newComment); 
            that._commentInput.value = '';
            that.setState({comment: ''});
            that.props.commentObj.setState({replies: oldReplies});
          } else {
            let oldComments = [];
            if (that.props.postObj && that.props.postObj.state && that.props.postObj.state.comments) {
              oldComments = that.props.postObj.state.comments;
            }
            oldComments.push(newComment);
            that._commentInput.value = '';
            that.setState({comment: ''});
            that.props.postObj.setState({comments: oldComments});
          }
        });
      } 
    } catch(e) {
      console.log('Post creation error: ' + e); 
    }   
  }

  updateComment(data) {
    this.setState({comment: data});
  }

  clearState() {
    console.log('Clear state has been called!');
    this.setState({pcHeight: '', placeHolder: '', childVisible: ''});
    this._commentInput.setState({comment: '', placeholder: 'Comment...'});
  }

  render() {
    let placeHolder = 'Comment...';
    let commentClassName = this.props.commentId ? 'replyInput' : 'commentInput';
    return (
      <div className='commentCreator'>
        <form onSubmit={(e) => this.submitComment(e)}>
          <img src={this.props.user.avatar} alt={this.props.user.username} style={{width: '30px'}} />
          &nbsp;&nbsp;&nbsp;
          <input className={commentClassName} user={this.props.user} placeholder={placeHolder} 
                 ref={(ref) => this._commentInput = ref} onChange={(e) => this.updateComment(e.target.value)} 
                 value={this.state.comment || ''} />
        </form>
      </div>
    );
  }
}
